import { graphql } from '../../gql';

export const GET_STATISTICS_QUERY = graphql(`
  query GetStatistics ($dateRange: DateRangeInput) {
    statistics(dateRange: $dateRange) {
      products
      orders {
        value
        changePercent
      }
      earnings {
        value
        changePercent
      }
    }
  }
`);

export const GET_ANALYTICS_QUERY = graphql(`
  query GetAnalytics($dateRange: DateRangeInput) {
    analytics(dateRange: $dateRange) {
      currentPeriodOrdersQuantity,
      currentPeriodOrdersValue,
      previousPeriodOrdersQuantity,
      previousPeriodOrdersValue,
      currentPeriodOrders {
        key,  
        value
      },
      previousPeriodOrders {
        key,  
        value
      }
    }
  }
`);

/**
 * The same field the products screen reads for its command header. The
 * products card needs the breakdown, not just a total — "14 products" doesn't
 * say whether two of them are stuck waiting on the shop.
 */
export const PRODUCT_STATUS_COUNTS_QUERY = graphql(`
  query DashboardProductStatusCounts {
    productStatusCounts {
      active
      draft
      archived
      new
      awaitingReview
      changesRequested
      total
    }
  }
`);

export const GET_DASHBOARD_ACTIONS_QUERY = graphql(`
  query GetDashboardActions {
    dashboardActions {
      ordersPendingApproval,
      ordersPendingFulfillment
    }
  }
`);

/**
 * The order dates behind the awaiting-acceptance count, so the alert can say
 * how long is left rather than only that a clock exists.
 *
 * `dashboardActions` returns counts and nothing else, and `sellerOrderConnection`
 * has no sort argument, so the oldest is found by reading the dates. Two fields
 * per row keeps that cheap. The cap is deliberate: a seller with more than 50
 * unaccepted orders is not being told anything new by a precise deadline, and
 * the alert's job — there is a clock, go and look — is already done.
 */
export const PENDING_ORDER_DATES_QUERY = graphql(`
  query DashboardPendingOrderDates {
    sellerOrderConnection(first: 50, sellerOrderStatus: [PENDING]) {
      edges {
        node {
          id
          orderDate
        }
      }
    }
  }
`);

